import { createStore } from 'owa-satcheljs';
import { DialogContentType } from './schema/Dialog';
import type TaskModule from './schema/TaskModule';
import type { DialogInfo } from './schema/Dialog';
import type { Instances, InstanceStore } from './schema/TaskModuleInstances';

// todo: rename to getTaskModulesStore
export const taskModules: () => Instances = createStore<Instances>('taskModuleInstances', {
    instances: new Map<string, InstanceStore>(),
});

export const instanceFactory = (id: string): InstanceStore =>
    /* eslint-disable-next-line owa-custom-rules/invoke-only-in-module-scope -- (https://aka.ms/OWALintWiki)
     * Baseline. DO NOT COPY AND PASTE!, this function can only be called in the module scope.
     *	> Function should only be invoked in module scope */
    createStore<TaskModule>(`taskModuleInstance_${id}`, {
        isOpen: false,
        dialogInfo: {} as DialogInfo,
        userClickTime: 0,
        contentType: DialogContentType.url,
        onSubmit: () => {},
        onDismiss: () => {},
    });
